var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['item', {'active': _vm.show}]},[_c('div',{staticClass:"title",on:{"click":_vm.clickTitleHandler}},[_vm._t("title",[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.label)?_c('label',[_vm._v(_vm._s(_vm.label))]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bf96b072","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CollapseItem.vue
// module id = 849
// module chunks = 1